import { render, staticRenderFns } from "./WhatsAppHelp.vue?vue&type=template&id=4ca79dc7"
import script from "./WhatsAppHelp.vue?vue&type=script&lang=js"
export * from "./WhatsAppHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports